"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var TopGameEditor = /** @class */ (function (_super) {
    __extends(TopGameEditor, _super);
    function TopGameEditor(props) {
        return _super.call(this, props) || this;
    }
    TopGameEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_GG = this.props.listGwsGameProviderGamesAvail.Subscribe("*", function (id, data) {
            _this.setState({ gws_gameprovider_games_avail: data.data });
        });
        this.SID_GS = this.props.listCmsGamesetAvail.Subscribe("*", function (id, data) {
            _this.setState({ cms_gameprovider_gameset_avail: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    cms_gameprovider_gameset_avail: [],
                    cms_gameprovider_gameset_id: _item.cms_gameprovider_gameset_id,
                    cms_gameprovider_gameset_title: _item.cms_gameprovider_gameset_title,
                    gws_gameprovider_game_id: _item.gws_gameprovider_game_id,
                    gws_gameprovider_game_title: _item.gws_gameprovider_game_title,
                    gws_gameprovider_games_avail: [],
                    gws_gameprovider_id: _item.gws_gameprovider_id,
                    gws_gameprovider_title: _item.gws_gameprovider_title,
                    is_auto_select_game: _item.is_auto_select_game,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    //selected_year: _item.selected_year,
                    //selected_month: _item.selected_month,
                    //selected_day: _item.selected_day,
                    //selected_hour: _item.selected_hour,
                    //selected_minute: _item.selected_minute,
                    //selected_second: _item.selected_second,
                    top_game_type_code: _item.top_game_type_code,
                    top_game_type_title: _item.top_game_type_title,
                    //is_custom_interval: _item.is_custom_interval,
                    change_game_interval_min: _item.change_game_interval_min
                }, function () {
                    _this.props.listGwsGameProviderGamesAvail.LoadData(_this.props.record.gws_gameprovider_id);
                    _this.props.listCmsGamesetAvail.LoadData(_this.props.record.gws_gameprovider_id);
                    _this.props.state.setExtBreadCrumbPath(["Редактирование топ игры"]);
                });
            }
        }
        else {
            this.setState({
                cms_gameprovider_gameset_avail: [],
                cms_gameprovider_gameset_id: 0,
                cms_gameprovider_gameset_title: "",
                gws_gameprovider_game_id: 0,
                gws_gameprovider_game_title: "",
                gws_gameprovider_games_avail: [],
                gws_gameprovider_id: 0,
                gws_gameprovider_title: "",
                is_auto_select_game: false,
                brand_id: 0,
                brand_title: "",
                app_currency_id: 0,
                app_currency_title: "",
                //selected_year: 2019,
                //selected_month: 1,
                //selected_day: 1,
                //selected_hour: 0,
                //selected_minute: 0,
                //selected_second: 0,
                top_game_type_code: 0,
                top_game_type_title: "",
                //is_custom_interval: false,
                change_game_interval_min: 10
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание топ игры"]);
            });
        }
        this.doReSetRules();
    };
    TopGameEditor.prototype.componentWillUnmount = function () {
        this.props.listGwsGameProviderGamesAvail.UnSubscribe(this.SID_GG);
        this.props.listCmsGamesetAvail.UnSubscribe(this.SID_GS);
    };
    TopGameEditor.prototype.doReSetRules = function () {
        this.setState({
            top_game_type_rules: { isError: false },
            brand_rules: { isError: false },
            gws_gameprovider_rules: { isError: false },
            gws_gameprovider_game_rules: { isError: false },
            cms_gameprovider_gameset_rules: { isError: false },
            change_game_interval_min_rules: { isError: false },
            app_currency_rules: { isError: false }
        });
    };
    TopGameEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.top_game_type_code) || (this.state.top_game_type_title.length === 0)) {
            this.setState({
                top_game_type_rules: {
                    isError: true,
                    errorMessage: "Поле [тип игры] не заполнено!"
                }
            });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: {
                    isError: true,
                    errorMessage: "Поле [бренд] не выбрано!"
                }
            });
            return false;
        }
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: {
                    isError: true,
                    errorMessage: "Поле [валюта] не выбрано!"
                }
            });
            return false;
        }
        if ((this.state.gws_gameprovider_id <= 0) || (this.state.gws_gameprovider_title.length === 0)) {
            this.setState({
                gws_gameprovider_rules: {
                    isError: true,
                    errorMessage: "Поле [геймпровайдер] не выбрано!"
                }
            });
            return false;
        }
        if ((this.state.gws_gameprovider_game_id <= 0) || (this.state.gws_gameprovider_game_title.length === 0)) {
            this.setState({
                gws_gameprovider_game_rules: {
                    isError: true,
                    errorMessage: "Поле [игра] не выбрано!"
                }
            });
            return false;
        }
        if (this.state.is_auto_select_game) {
            if (this.state.change_game_interval_min <= 0) {
                this.setState({
                    change_game_interval_min_rules: {
                        isError: true,
                        errorMessage: "Поле [интервал] имеет некорректное значение!"
                    }
                });
                return false;
            }
            if ((this.state.cms_gameprovider_gameset_id <= 0) || (this.state.cms_gameprovider_gameset_title.length === 0)) {
                this.setState({
                    cms_gameprovider_gameset_rules: {
                        isError: true,
                        errorMessage: "Поле [геймсет] не выбрано!"
                    }
                });
                return false;
            }
        }
        return true;
    };
    TopGameEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                cms_gameprovider_gameset_id: this.state.cms_gameprovider_gameset_id,
                gws_gameprovider_game_id: this.state.gws_gameprovider_game_id,
                gws_gameprovider_id: this.state.gws_gameprovider_id,
                is_auto_select_game: this.state.is_auto_select_game,
                app_currency_id: this.state.app_currency_id,
                // is_custom_interval: this.state.is_custom_interval,
                change_game_interval_min: this.state.change_game_interval_min,
                top_game_type_code: this.state.top_game_type_code,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Топ игра изменена!");
            });
        }
    };
    TopGameEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                cms_gameprovider_gameset_id: this.state.cms_gameprovider_gameset_id,
                brand_id: this.state.brand_id,
                gws_gameprovider_game_id: this.state.gws_gameprovider_game_id,
                gws_gameprovider_id: this.state.gws_gameprovider_id,
                is_auto_select_game: this.state.is_auto_select_game,
                app_currency_id: this.state.app_currency_id,
                //is_custom_interval: this.state.is_custom_interval,
                change_game_interval_min: this.state.change_game_interval_min,
                top_game_type_code: this.state.top_game_type_code,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Топ игра добавлена!");
            });
        }
    };
    TopGameEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    TopGameEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить топ игру";
        }
        else {
            return "Изменить топ игру";
        }
    };
    TopGameEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип игры:", placeholder: "Выберите тип игры" }, value: { key: this.state.top_game_type_code, value: this.state.top_game_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        top_game_type_code: newVal.key,
                        top_game_type_title: newVal.value,
                        top_game_type_rules: { isError: false },
                    });
                }, items: this.props.topGameTypesAvail, required: true, rules: this.state.top_game_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.brandsAvail, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.appCurrencyAvail, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геймпровайдер:", placeholder: "Выберите геймпровайдер" }, value: { key: this.state.gws_gameprovider_id, value: this.state.gws_gameprovider_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_id: newVal.key,
                        gws_gameprovider_title: newVal.value,
                        gws_gameprovider_rules: { isError: false },
                        gws_gameprovider_game_id: 0,
                        gws_gameprovider_game_title: "",
                        cms_gameprovider_gameset_id: 0,
                        cms_gameprovider_gameset_title: ""
                    }, function () {
                        _this.props.listGwsGameProviderGamesAvail.LoadData(_this.state.gws_gameprovider_id);
                        _this.props.listCmsGamesetAvail.LoadData(_this.state.gws_gameprovider_id);
                    });
                }, items: this.props.gwsGameprovidersAvail, required: true, rules: this.state.gws_gameprovider_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игра:", placeholder: "Выберите игру" }, value: { key: this.state.gws_gameprovider_game_id, value: this.state.gws_gameprovider_game_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_game_id: newVal.key,
                        gws_gameprovider_game_title: newVal.value,
                        gws_gameprovider_game_rules: { isError: false }
                    });
                }, items: this.state.gws_gameprovider_games_avail, required: true, rules: this.state.gws_gameprovider_game_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Автовыбор игры", value: this.state.is_auto_select_game, onChecked: function (checked) { _this.setState({ is_auto_select_game: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геймсет :", placeholder: "Выберите геймсет" }, value: { key: this.state.cms_gameprovider_gameset_id, value: this.state.cms_gameprovider_gameset_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        cms_gameprovider_gameset_id: newVal.key,
                        cms_gameprovider_gameset_title: newVal.value,
                        cms_gameprovider_gameset_rules: { isError: false }
                    });
                }, items: this.state.cms_gameprovider_gameset_avail, required: true, rules: this.state.cms_gameprovider_gameset_rules, disabled: !this.state.is_auto_select_game }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Интервал смены игры(минут):", placeholder: "Введите интервал смены игры, минут" }, values: { max: 9999999999, min: 1, value: this.state.change_game_interval_min }, onValueChanged: function (newVal) {
                    _this.setState({
                        change_game_interval_min: newVal,
                        change_game_interval_min_rules: { isError: false }
                    });
                }, required: true, rules: this.state.change_game_interval_min_rules, disabled: !this.state.is_auto_select_game }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return TopGameEditor;
}(React.Component));
exports.default = TopGameEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_top_games/ui/component/TopGameEditor.tsx
// module id = 2353
// module chunks = 0